import React from 'react'
import { Card, Typography, Col } from 'antd'

const RiepilogoCard = (props) => {
  return (
    <Col xs={24} sm={24} lg={12}>
      <Card
        className='w-full shadow-xl border-2'
        style={{
          marginTop: 8,
          marginBottom: 8
        }}
      >
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          {props.cardTitle}
        </Typography.Title>
        {props.children}
      </Card>
    </Col>
  )
}

export default RiepilogoCard
